export function AuthLayout({ children }) {
    return <div>{children}</div>;
}
